import { noop, safeOnError } from '@rehaje/shared'

import { addPostEffect, DISPOSED, Effect } from '../signal'

import type { PostEffect } from '../signal'
import type { EffectOptions, Subscriber } from '../types'
import type { Callback } from '@rehaje/shared'

export class Tracker extends Effect {
  _postEffect?: PostEffect

  constructor(subscriber?: Subscriber, options?: EffectOptions)
  constructor(postEffect?: PostEffect, options?: EffectOptions) {
    super(noop)
    this._onError = safeOnError(options?.onError)
    if (postEffect) {
      this._postEffect = postEffect?.bind(undefined)
      this._postEffect._onError = safeOnError(options?.onError)
      this._postEffect._executed = true
    }
  }

  override _callback(): void {
    if (this._postEffect) addPostEffect(this._postEffect)
  }

  override _dispose(): void {
    super._dispose()
    if (this._postEffect) this._postEffect._disposed = true
  }

  dispose() {
    this._dispose()
  }

  track(tracker?: Callback) {
    const finish = this._start()
    try {
      if (!tracker || this._flags & DISPOSED) return
      tracker()
      this._version++
    } catch (error) {
      this._onError?.(error, this._version === 0)
      this._dispose()
      throw error
    } finally {
      finish()
    }
  }
}
